export class UserPermission {
    IdEmpresa: number;
    IdOrganizacion: number;
    IdUsuario: string;
    Ruts: string[];
    Pi: boolean;
    AdminCartera: boolean;
}